import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"elevator elevation-5",attrs:{"dark":_vm.darkElevator,"height":"","width":"30"}},[_c(VLayout,{attrs:{"column":"","align-center":""}},[_c(VFlex,[_c(VBtn,{attrs:{"depressed":"","icon":""},on:{"click":_vm.floorUp}},[_c(VIcon,[_vm._v("expand_less")])],1)],1),_c(VFlex,[_vm._v(_vm._s(_vm.currentFloor))]),_c(VFlex,[_c(VBtn,{attrs:{"depressed":"","icon":""},on:{"click":_vm.floorDown}},[_c(VIcon,[_vm._v("expand_more")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }